import { WarningFilled } from '@carbon/icons-react';
import { useTranslation } from 'react-i18next';

const LOCK_END = new Date(2026, 2, 25, 23, 59, 59);

export const isPaymentSystemLocked = (): boolean => {
  return new Date() <= LOCK_END;
};

export function PaymentLockdownBanner() {
  const { t } = useTranslation();

  if (!isPaymentSystemLocked()) {
    return null;
  }

  const nextDay = new Date(LOCK_END);
  nextDay.setDate(nextDay.getDate() + 1);
  const endDate = nextDay.toLocaleDateString('bg-BG');

  return (
    <div className="food-management__info-banner food-management__info-banner--warning">
      <WarningFilled className="food-management__info-banner__icon" />
      <span className="food-management__info-banner__text">
        {t('TAXES.MESSAGES.PAYMENTS_LOCKED', { endDate })}
      </span>
    </div>
  );
}
